import { useState, useEffect, useMemo } from "react";
import ChatWrapper from "../chat/ChatWrapper";
import { Widget } from "./Widget";
import { Stack } from "@fluentui/react";
import { readFromSessionStorage, writeToSessionStorage } from "../../utils/localStorage";
// import { useIsMobile } from "../../hooks/useIsMobile";

const TOOLTIP_STORAGE_KEY = "leora_tooltip_is_hidden";

export const WidgetWrapper = () => {

  // const isMobile = useIsMobile(900);

  const queryParams = useMemo(() => new URLSearchParams(window.location.search), []);
  const leoraMode = queryParams.get("leora"); // "open" | "full"

  const [showModel, setShowModel] = useState(() => !!leoraMode);

  const [hideTooltip, setHideTooltip] = useState(() => {
    const stored = readFromSessionStorage(TOOLTIP_STORAGE_KEY);
    return stored === true;
  });

  useEffect(() => {
    writeToSessionStorage(TOOLTIP_STORAGE_KEY, hideTooltip);
  }, [hideTooltip]);

  // // for testing
  // const chatBackground = isMobile ? "src/componentsTest/assets/backgrounds/chatmobile.png" : "src/componentsTest/assets/backgrounds/hero.png"

  return (
      // <Stack style={{ background: `url(${chatBackground}) no-repeat left top / cover`, width: '100%', height: '200vh' }}>
      <Stack>
        {showModel ? (
          <ChatWrapper setShowModel={setShowModel} initialFullScreen={leoraMode === "full"}/>
        ) : (
          <Widget setShowModel={setShowModel} hideTooltip={hideTooltip} setHideTooltip={setHideTooltip}/>
        )}
      </Stack>
  )
}